import type {RutaProd} from '../../../../runtime/rutas';
export default {"ruta": "/sistema/cotizaciones/lista", "documento": "quotation", "acceso": "sesion", "filas": ["087"], "cita": "Areas/Quotation/Controllers/QuotationController.cs"} satisfies RutaProd;
